import React, { useState, useEffect } from 'react';
import { bookingShape, passengerShape } from 'constants/propTypes';

import { Container, ActionHeader, ActionContent, AuditInfo, HeaderToggle, HeaderToggleWrapper } from './CaptureDetail.styles';

import CaptureDetailForm from './CaptureDetailForm';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const CaptureDetail = ({ booking, passenger, hasTravelDocumentBeenProvided, isTravelDocumentRequired, refreshTravelDocs }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [shouldTransition, setShouldTransition] = useState(false);
  const [height, setHeight] = useState(0);

  const contentEl = React.createRef();

  let passportInformationLabel = 'advancedPaxInfo.informationNotRequired';

  if (isTravelDocumentRequired) {
    switch (hasTravelDocumentBeenProvided) {
      case true:
        passportInformationLabel = 'advancedPaxInfo.informationCompleted';
        break;
      case false:
        passportInformationLabel = 'advancedPaxInfo.informationRequired';
        break;
      default:
        passportInformationLabel = 'advancedPaxInfo.informationNotRequired';
        break;
    }
  }

  useEffect(() => {
    if (!contentEl.current || height !== 0) {
      return;
    }

    const computedHeight = window.getComputedStyle(contentEl.current).height;
    setHeight(computedHeight);

    setIsOpen(false);
    setShouldTransition(true);
  }, [contentEl, height]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Container data-cy="capture-detail">
      <ActionHeader onClick={toggle}>
        <HeaderToggleWrapper>
          <HeaderToggle isExpanded={isOpen} />
        </HeaderToggleWrapper>

        <div data-cy="history-detail-action-type">
          {passenger.firstName} {passenger.lastName}
        </div>

        <AuditInfo hasTravelDocumentBeenProvided={hasTravelDocumentBeenProvided} isTravelDocumentRequired={isTravelDocumentRequired}>
          <FormattedMessage id={passportInformationLabel} />
        </AuditInfo>
      </ActionHeader>

      <ActionContent height={height} shouldTransition={shouldTransition} isExpanded={isOpen} ref={contentEl}>
        <CaptureDetailForm
          booking={booking}
          passenger={passenger}
          refreshTravelDocs={refreshTravelDocs}
          hasTravelDocumentBeenProvided={hasTravelDocumentBeenProvided}
        />
      </ActionContent>
    </Container>
  );
};

CaptureDetail.propTypes = {
  booking: bookingShape,
  passenger: passengerShape,
  isTravelDocumentRequired: PropTypes.bool,
  hasTravelDocumentBeenProvided: PropTypes.bool,
  refreshTravelDocs: PropTypes.func.isRequired
};

export default CaptureDetail;
